var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./modalOuvertureExercice.ts"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5f5723c8\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./modalOuvertureExercice.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/exercices/modalOuvertureExercice/modalOuvertureExercice.vue.html
// module id = RiBH
// module chunks = 2